import React from 'react';
import Type from 'prop-types';
import { Typography } from "@mui/material";
import { useTranslation } from 'hooks';
import { formatDate } from 'utils/date';

const FormattedDate = ({ value, token, ...typographyProps }) => {
  const { locale } = useTranslation();
  const formattedValue = formatDate(value, token, locale);

  return <Typography {...typographyProps}>{formattedValue}</Typography>;
};

FormattedDate.propTypes = {
  value: Type.oneOfType([Type.instanceOf(Date), Type.string]).isRequired,
  token: Type.string.isRequired,
  color: Type.string,
  component: Type.node,
  variant: Type.string,
  align: Type.string,
};

FormattedDate.defaultProps = {
  color: 'textPrimary',
  align: 'inherit',
  component: 'span',
  variant: 'body2',
};

export default FormattedDate;
